import { MusicGameCharacter } from "GameObjects/MusicGame/Character";

export class MusicGamePiper extends MusicGameCharacter {

    protected animations = {
        idle: "Idle",
        idleToReady: "Idle to Ready",
        ready: "Getting Ready",
        playing: "Playing",
    };

    constructor(pData: {id: number}) {
        super({name: 'piper', skeleton: 'Piper Front', ...pData});
        this.playAnimation(this.animations.idle);
        this._spine.update(0);
    }

}